module.exports = __webpack_public_path__ + "static/media/Twitter.0ec064d2.svg";